import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { useFlags } from "launchdarkly-react-client-sdk";
import { useSelector } from "react-redux";
import { GLOBAL_MEETING_DATA } from "../../../constants/PublicVariables";
import { poweredBy } from "../../../constants/Constants";
import { isPoweredByAvailable, isSpeedTestLinkAvailable } from "../../../shared/function";
import useLanguageChange from "../../../hooks/useLanguageChange";

const CallFooter = ({ localisedValuesForCallFooter }) => {
    const ldFlags = useFlags();

    const { isCompanyAvailableData, privacyPolicyData } = useSelector((state) => state.onLoadData);

    const localisedValues = useLanguageChange();

    /* Handle to show Is SpeedTest Link Available is visible or not with data */
    const getIsSpeedTestLinkAvailableData = useMemo(() => {
        if (privacyPolicyData) {
            const privacyPolicyFooterInfo = {
                isFooterVisible: privacyPolicyData?.footerTextVisibility,
                footerText: privacyPolicyData?.footerText,
                footerURL: privacyPolicyData?.footerUrl,
            };
            return isSpeedTestLinkAvailable(null, privacyPolicyFooterInfo, ldFlags?.helpView, localisedValues);
        } else if (isCompanyAvailableData) {
            const companyFooterInfo = {
                isFooterVisible: isCompanyAvailableData?.footerIsVisible,
                footerText: isCompanyAvailableData?.footerText,
                footerURL: isCompanyAvailableData?.footerUrl,
            };
            return isSpeedTestLinkAvailable(companyFooterInfo, null, ldFlags?.helpView, localisedValues);
        }
    }, [isCompanyAvailableData, privacyPolicyData, ldFlags, localisedValues]);

    /* Handle to show powered by available is visible or not with data */
    const getIsPoweredByAvailable = useMemo(() => {
        if (privacyPolicyData) {
            return isPoweredByAvailable(privacyPolicyData?.powerBy);
        } else if (isCompanyAvailableData) {
            return isPoweredByAvailable(isCompanyAvailableData?.powerByIsVisible);
        }
    }, [isCompanyAvailableData, privacyPolicyData]);

    return (
        <div className='call-footer'>
            <div className='call-footer-list'>
                {(getIsSpeedTestLinkAvailableData?.isVisible || GLOBAL_MEETING_DATA.getIsSpeedTestLinkAvailableData?.isVisible) &&
                    (getIsSpeedTestLinkAvailableData?.footerHtml || GLOBAL_MEETING_DATA.getIsSpeedTestLinkAvailableData?.footerHtml)}
                {(getIsPoweredByAvailable || GLOBAL_MEETING_DATA.getIsPoweredByAvailable) && (
                    <div className='call-footer-box'>
                        <span className='for-text'>{localisedValuesForCallFooter.powered_by + " "}</span>
                        <a className='for-link' target='_blank' href={poweredBy}>
                            Blitzz
                        </a>
                    </div>
                )}
            </div>
        </div>
    );
};

CallFooter.propTypes = {
    localisedValuesForCallFooter: PropTypes.object.isRequired,
};

export default CallFooter;
